import React, { FC, Fragment } from "react";
import ColumnText from "./ColumnText";

export type TableLoaderProps = {
  columns: number;
  rows?: number;
};

export const TableLoader: FC<TableLoaderProps> = ({ columns, rows = 6 }) => {
  return (
    <Fragment>
      <table className="min-w-full divide-y divide-gray-300">
        <thead>
          <tr>
            {new Array(columns).fill(undefined).map(() => (
              <th
                scope="col"
                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
              >
                <p className="animate-pulse bg-gray-300 w-20 md:w-28 lg:w-full flex h-4 rounded-sm"></p>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {new Array(rows).fill(undefined).map(() => (
            <tr>
              {new Array(columns).fill(undefined).map(() => (
                <ColumnText
                  title={
                    <p className="animate-pulse bg-gray-300 w-full flex h-4 rounded-sm"></p>
                  }
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </Fragment>
  );
};
